import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=617a8626&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=617a8626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a8626",
  null
  
)

export default component.exports